import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { findUser } from '../actions/userActions';
import { CART } from '../constants/routes';
import { isAppPWA } from '../utils/helper-functions';
import useAxios from '../axios/useAxios';

import { useScanVerification } from './scanCheck/hooks/useScanVerification';
import { useManualVerification } from './scanCheck/hooks/useManualVerification';

import SuccessNotif from '../components/SuccessNotif';
import ScannerContainer from './scanCheck/ScannerContainer';
import ManualVerificationOverlay from './scanCheck/ManualVerificationOverlay';

import { checkStateCartItems } from '../utils/cartItem.js';
import { useFunnelTracking } from '../posthog/funnelTracking';
import { useUserLoginStatus } from '../utils/hooks';
import { usePerformanceContext } from '../context/PerformanceContext.jsx';

const ScanCheck = () => {
  const { cartItems } = useSelector((state) => state.cart);
  const { store } = useSelector((state) => state.store);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const axiosInstance = useAxios();
  const isPWA = isAppPWA();
  const CHECKOUT_TYPE_MANUAL = 'manual';

  const [explicationcheck, setExplicationCheck] = useState(true);
  const [checkoutQrScanned, setCheckoutQrScanned] = useState(false);

  const { markComplete } = usePerformanceContext();

  const {
    setCode,
    isDestroy,
    isScanditLoaded,
  } = useScanVerification(cartItems, user, axiosInstance);

  const {
    manualVerification,
    setManualVerification,
    checkIfOrderHasBeenManualyVerified,
  } = useManualVerification(cartItems, axiosInstance);
  const isLoggedIn = useUserLoginStatus();
  const { trackPageViewScanCheck, trackFunnelOrderPaid } = useFunnelTracking();

  useEffect(() => {
    trackPageViewScanCheck({});
    trackFunnelOrderPaid({
                           transaction_id: cartItems?._id,
                           order_value: cartItems?.promoPrice || cartItems?.itemsPrice || 0,
                           items_purchased: cartItems?.orderItems?.length || 0,
                           payment_method: cartItems?.paymentMethod,
                           user_loggedIn: isLoggedIn,
                         });
  }, [trackPageViewScanCheck]);

  function closeAnimManualVerification() {
    if (cartItems) {
      const orderId = cartItems?._id;

      setManualVerification(false);
      navigate(`/receipt/${orderId}`);
    } else {
      console.error('There is no cartItem to redirect to receipt screen');
      navigate('/');
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    if (user?._id) {
      dispatch(findUser(user, axiosInstance, navigate));
    }

    const scanditVideo = document.querySelector('.scandit .scandit-video');
    if (scanditVideo) scanditVideo.style.height = '30vh';
  }, []);

  useEffect(() => {
    let intervalManualVerification;
    let timeoutAnimManualverification;

    const orderId = cartItems?._id;
    checkStateCartItems(cartItems, navigate, dispatch, `/receipt/${orderId}`);

    if (cartItems) {
      if (!cartItems?.manualVerification) {
        if (!intervalManualVerification) {
          intervalManualVerification = setInterval(checkIfOrderHasBeenManualyVerified, 4000);
        }
      }

      if (cartItems?.verification) {
        const orderId = cartItems._id;
        setCheckoutQrScanned(true);

        if (store?.checkoutVerificationType === CHECKOUT_TYPE_MANUAL) {
          setManualVerification(true);
          timeoutAnimManualverification = setTimeout(() => {
            closeAnimManualVerification();
          }, 30 * 1000);
        } else {
          navigate(`/receipt/${orderId}`);
        }
      }

      if (!cartItems?.isPaid) {
        navigate(CART);
      }

      if (cartItems?.manualVerification) {
        setCheckoutQrScanned(true);

        if (timeoutAnimManualverification) {
          clearTimeout(timeoutAnimManualverification);
        }
        closeAnimManualVerification();
      }
    }

    return () => {
      if (intervalManualVerification) {
        clearInterval(intervalManualVerification);
      }
      if (timeoutAnimManualverification) {
        clearTimeout(timeoutAnimManualverification);
      }
    };
  }, [cartItems]);




  useEffect(() => {
    if (cartItems?.isPaid && isScanditLoaded && !isDestroy &&
      !manualVerification && axiosInstance && !user.userLoading) {
      markComplete();
    }
  }, [cartItems, isScanditLoaded, isDestroy, manualVerification, axiosInstance, user.userLoading, markComplete]);

  if (!cartItems) return null;

  return (
    <>
      {!explicationcheck && (
        <SuccessNotif actioner={() => {
          setExplicationCheck(true);
        }} />
      )}

      {!checkoutQrScanned && (
        <ScannerContainer
          isPWA={isPWA}
          isScanditLoaded={isScanditLoaded}
          isDestroy={isDestroy}
          onScan={(scanResult) => setCode(scanResult.barcodes[0].data)}
          onExplanationClick={() => setExplicationCheck(false)}
        />
      )}

      {checkoutQrScanned && manualVerification && (
        <ManualVerificationOverlay />
      )}
    </>
  );
};

export default ScanCheck;
